<div class="slack-connect-redirect">
  <mat-progress-spinner *ngIf="loading" mode="indeterminate" diameter="48"></mat-progress-spinner>

  <div class="slack-connect-redirect__text">
    <div class="slack-connect-redirect__title">
      {{ 'CHANGE_MONITORING.CONNECT_W_SLACK' | translate }}
    </div>
    <div class="slack-connect-redirect__subtitle" *ngIf="!errorMessage">
      {{ 'CHANGE_MONITORING.SLACK_SETUP_MSG' | translate }}
    </div>
    <div class="slack-connect-redirect__error" *ngIf="errorMessage">
      {{ errorMessage | translate }}
    </div>
  </div>
</div>
